<script setup lang="ts">
useHead({
  meta: [
    {
      name: "viewport",
      content: computed(() => {
        const userAgent = window?.navigator.userAgent;

        return userAgent &&
          (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i))
          ? "width=device-width, initial-scale=1, maximum-scale=1"
          : "width=device-width, initial-scale=1";
      }),
    },
  ],
});

const { searchParams, pathname } = useRequestURL();
</script>

<template>
  <div id="top">
    <NuxtLoadingIndicator color="#076b9c" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <LazyCookieInfoModal
      v-if="!searchParams.has('_storyblok') && !pathname.includes('/embed/')"
    />
  </div>
</template>

<style lang="scss" scoped>
@include fade-transition;
</style>
